document.addEventListener('DOMContentLoaded', function () {
    const headerLogoScrollToTop = document.getElementById('header-logo-icon');

    if (headerLogoScrollToTop) {
        headerLogoScrollToTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    // Add scroll to parameters button functionality
    const scrollToParametersButton = document.querySelector('.scroll-to-subscription');

    if (scrollToParametersButton) {
        scrollToParametersButton.addEventListener('click', function () {
            const parametersSection = document.querySelector('.main-cart-button');

            if (parametersSection) {
                parametersSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        });
    }

    let productFormButtons = document.querySelector('.main-cart-button');

    if (!productFormButtons) {
        productFormButtons = document.querySelector('button');
    }

    const topSection = document.getElementById('top-section');

    function handleScroll() {
        const buttonTop = productFormButtons.getBoundingClientRect().top;

        topSection.style.display = buttonTop < 0 ? 'block' : 'none';
    }

    window.addEventListener('scroll', handleScroll);

    handleScroll();

    // Listen for subscription widget plan & tier changes to dynamically update sticky bar promo badges
    const stickyPromoBadges = document.querySelectorAll('[data-sticky-promo-badge]');
    if (stickyPromoBadges.length > 0) {
        function updateStickyPromoBadge(detail) {
            if (!detail) return;

            const isDe = document.documentElement.lang === 'de' || window.location.pathname.startsWith('/de');

            stickyPromoBadges.forEach(function (stickyPromoBadge) {
                const defaultDiscount = stickyPromoBadge.getAttribute('data-default-discount');
                const saveLabelEl = stickyPromoBadge.querySelector('.save-label') || stickyPromoBadge;

                let discount = detail.discountPercentage;
                if (detail.tierType === 'one-time') {
                    discount = discount || defaultDiscount;
                }

                if (discount) {
                    const text = isDe ? `Spare ${discount}%` : `Save ${discount}%`;
                    saveLabelEl.textContent = text;
                    stickyPromoBadge.style.display = '';
                } else if (defaultDiscount && detail.tierType === 'one-time') {
                    const text = isDe ? `Spare ${defaultDiscount}%` : `Save ${defaultDiscount}%`;
                    saveLabelEl.textContent = text;
                    stickyPromoBadge.style.display = '';
                } else if (!discount && detail.tierType === 'subscribe') {
                    // If the selected subscription plan has no percentage configured
                    if (detail.badgeEn || detail.badgeDe) {
                        saveLabelEl.textContent = isDe ? (detail.badgeDe || detail.badgeEn) : (detail.badgeEn || detail.badgeDe);
                        stickyPromoBadge.style.display = '';
                    }
                }
            });
        }

        // Check if a widget was already initialized before this script executed
        if (window._lastSubscriptionPlanDetail) {
            updateStickyPromoBadge(window._lastSubscriptionPlanDetail);
        } else {
            // Also inspect the DOM directly for an already checked input
            const prechecked = document.querySelector('.native-subscription-option__input:checked, [data-purchase-option].is-selected .native-subscription-option__input:checked');
            if (prechecked) {
                const isOneTime = prechecked.value === 'one-time' || !prechecked.dataset.sellingPlanId;
                updateStickyPromoBadge({
                    tierType: isOneTime ? 'one-time' : 'subscribe',
                    discountPercentage: prechecked.dataset.discountPercentage || '',
                    badgeEn: prechecked.dataset.badgeEn || '',
                    badgeDe: prechecked.dataset.badgeDe || '',
                    activeInput: prechecked
                });
            }
        }

        document.addEventListener('vl:subscription-plan-change', function (e) {
            updateStickyPromoBadge(e.detail);
        });
    }

});